import React from "react";

import DetailsCard from "../../components/card/details-card";
import { GET_STATISTICS_QUERY } from "../../graphql/queries/statistics";
import { useQuery } from "@apollo/client";
import Loader from "../../components/loader/loader";
import RevenueChart from "../../components/revenue-graph/revenue-graph";

const Dashboard = () => {
  const { data, loading, error } = useQuery(GET_STATISTICS_QUERY, {
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <Loader sizeClass={"size--medium"} />;
  }

  if (error) {
    return <div className="">Something went wrong</div>;
  }

  return (
    <div className="display-page">
      <div className="display-page__cards">
        <DetailsCard
          color="success"
          title="Active clients"
          mainValue={data.activeClientsCount.toString() ?? ""}
          statisticValue=""
          statisticDescription="Clients currently active on the platform"
          icon={"/images/user.svg"}
        />

        <DetailsCard
          color="success"
          title="New Clients this month"
          mainValue={data?.activeClientsThisMonthCount?.toString() ?? ""}
          statisticValue={`${
            data?.activeClientsLastMonthCount > 0
              ? (
                  (data?.activeClientsThisMonthCount -
                    data?.activeClientsLastMonthCount) /
                  data?.activeClientsLastMonthCount
                ).toFixed(2) * 100
              : 100
          }%`}
          statisticDescription={`${
            data?.activeClientsThisMonthCount - 1 < 0 ? "less" : "more"
          } than last month`}
          direction={
            data?.activeClientsThisMonthCount -
              data?.activeClientsLastMonthCount <
            0
              ? "negative"
              : "positive"
          }
          icon={"/images/user.svg"}
        />
        <DetailsCard
          color="active"
          title="Meters with expired credit"
          mainValue={data.clientsWithExpiredCreditCount.toString() ?? ""}
          statisticValue=""
          statisticDescription="Clients who has expired meter credit."
          icon={"/images/printer.svg"}
        />

        <DetailsCard
          color="danger"
          title="month-to-date revenue"
          mainValue={`R${data.monthlyRevenue.toFixed(2) ?? 0}`}
          statisticValue={`${
            data.lastMonthRevenue > 0
              ? (
                  ((data.monthlyRevenue - data.lastMonthRevenue) /
                    data.lastMonthRevenue) *
                  100
                ).toFixed(2)
              : 100
          }%`}
          statisticDescription={`${
            data.monthlyRevenue - data.lastMonthRevenue < 0 ? "less" : "more"
          } than last month.`}
          icon={"/images/printer.svg"}
          direction={`${
            data.monthlyRevenue - data.lastMonthRevenue < 0
              ? "negative"
              : "positive"
          }`}
        />
      </div>
      <RevenueChart />
    </div>
  );
};

export default Dashboard;
